<template>
    <div class="container-md container-app p-0 ">
        <div class="wrapper">
            <div class="header"><h1>{{$t('ristorante_dettaglio_titolo')}}</h1></div>
            <div class="content-full">
              <div class="title">{{$t('layout_chi_siamo')}}</div>
              <hr>
                <div class="sezione">
                    <div class="row">
                        <div class="col-12">
                            <p class="text-justify" v-html="this.getLocaleDescription()"></p>
                        </div>
                        <div class="col-12" v-if="this.info_locale && this.info_locale.foto.length">
                            <div class="row text-center">
                                <div class="col-lg-6">
                                    <img :src="getPhotoImage(this.info_locale.foto[0].codice)"
                                         class="img-fluid "
                                         style="margin-bottom:11px; ">
                                </div>
                                <div class="col-lg-6 text-center" v-if="this.info_locale.foto.length > 1">
                                    <div class="row">
                                        <div class="col-12 col-lg-6" v-for="(photo, i) in this.info_locale.foto.slice(1)">
                                            <img :src="getPhotoImage(photo.codice)"
                                                 class="img-fluid"
                                                 style="margin-bottom:11px;">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div class="container d-none">
                    <div class="row row-sezione">
                        <div class="col-12 text-center">
                            <router-link :to="{name:'home'}">
                                <button type="button" class="btn btn-default">
                                    {{$t('prenotazione_tavolo.torna_home')}}
                                </button>
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import {getImage} from "../api/core";
import {getMixedInfo} from "../api/restaurant";

export default {
    name: "Presentation",
    data() {
        return {
            info_locale: null
        }
    },
    created() {
        this.fetch();
    },
    computed: {
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapGetters('restaurant', {
            getLocaleDescription: 'localeDescription',
            locale_photos: 'localePhotos',
        })
    },
    methods: {
        fetch: function () {
            getMixedInfo(
                this.language, {
                    id_ristorante: this.id_ristorante,
                    id_locale: this.locale.id,
                    info_locale: true
                },
            )
                .then((response) => {
                    this.info_locale = response.info_locale;
                }).catch(({messages}) => alert(messages.join('\n')));
        },
        getPhotoImage: function (code) {
            return getImage(this.language, this.id_ristorante, code);
        }
    }
}
</script>
